// src/components/LazyFallback.js
import React from 'react';
import './LazyFallback.css';

const LazyFallback = () => (
  <div className="lazy-fallback">
    <div className="lazy-fallback-spinner" />
    <div className="lazy-fallback-text">Chargement…</div>
  </div>
);

export default LazyFallback;